import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  Card,
  Grid,
  MenuItem,
  Select,
  CardContent,
  Typography,
  CardHeader,
  Menu,
  Divider,
  IconButton,
} from "@material-ui/core";
import {
  AddBox,
  MoreVert,
  AddCircle,
  Warning,
  WarningOutlined,
  NoteAlt,
  Description,
  BorderColor,
} from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import Avatar from "@material-ui/core/Avatar";
import red from "@material-ui/core/colors/red";
import MenuOpciones from "./MenuOpciones";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },

  // avatar: {
  //   fontSize: 12,
  // },
  avatar1: {
    fontSize: 12,
    color: "#fff",
    backgroundColor: theme.palette.grey[500],
  },
  redAvatar: {
    fontSize: 12,
    color: "#fff",
    margin: 5,
    backgroundColor: red[500],
  },
  card: {
    maxWidth: 250,
    margin: "auto",
    transition: "0.3s",
    boxShadow: "0 8px 40px -12px rgba(194,194,194,0.7)",
    "&:hover": {
      boxShadow: "0 16px 70px -12.125px rgba(0,0,255,0.3)",
    },
    borderRadius: "10px",
  },
}));

export default function CardTarea(props) {
  const {
    register,
    errors,
    defaultItem,
    ctl,
    clickEditar,
    clickCerrarT,
    clickDetalleTarea,
    cerrar,
    permisos,
    tareas_by_user,
  } = props;

  const [data, setData] = useState([]);
  const [modal, setModal] = useState({ open: false, titulo: "" });
  const classes = useStyles();
  const clickNuevo = () => {
    clickEditar(anchorEl.row);
  }; //setModal({ open: true });
  const clickDetalle = () => {
    clickDetalleTarea(anchorEl.row);
  }; //setModal({ open: true });
  const clickCerrar = () => {
    // se cierra tarea
    clickCerrarT(anchorEl.row);
  }; //setModal({ open: true });
  const [inputValue, setInputValue] = React.useState("");
  const abrirMenu = (row) => (event) => {
    setAnchorEl({ current: event.currentTarget, row: row, tipo: 1 });
  };
  const abrirMenuC = (row) => (event) => {
    setAnchorEl({ current: event.currentTarget, row: row, tipo: 2 });
  };
  const abrirMenuCe = (row) => (event) => {
    setAnchorEl({ current: event.currentTarget, row: row, tipo: 3 });
  };
  const [anchorEl, setAnchorEl] = useState({ current: null });
  const cerrarModal = () => {
    setModal({ open: false });
  };
  const cerrarMenu = () => setAnchorEl({ ...anchorEl, current: null });
  // console.log(permisos);
  const accionesFila = [
    {
      label: "EDITAR TAREA",
      onClick: clickNuevo,
      enabled: permisos?.editar_tarea,
    },
    { label: "VER TAREA", onClick: clickDetalle, enabled: true },
  ];
  const accionesFilaT = [
    {
      label: "EDITAR TAREA",
      onClick: clickNuevo,
      enabled: permisos?.editar_tarea,
    },
    { label: "VER TAREA", onClick: clickDetalle, enabled: true },
    {
      label: "CERRAR TAREA",
      onClick: clickCerrar,
      enabled: permisos?.cerrar_t,
    },
  ];
  const accionesFilaC = [
    { label: "VER TAREA", onClick: clickDetalle, enabled: true },
  ];

  return (
    <React.Fragment>
      <Menu
        anchorEl={anchorEl.current}
        keepMounted
        open={Boolean(anchorEl.current)}
        onClose={cerrarMenu}
      >
        <MenuOpciones
          accionesFila={
            anchorEl.tipo && anchorEl.tipo == 1
              ? accionesFila
              : anchorEl.tipo && anchorEl.tipo == 2
              ? accionesFilaT
              : accionesFilaC
          }
          cerrarMenu={cerrarMenu}
          anchorEl={anchorEl}
        />
      </Menu>
      {/* <Menu
        anchorEl={anchorEl.current}
        keepMounted
        open={Boolean(anchorEl.current)}
        onClose={cerrarMenu}
      >
        {accionesFila
          .filter((accion) =>
            typeof accion.enabled === "function"
              ? accion.enabled(anchorEl.row || {})
              : accion.enabled
          )
          .map((accion, index) => (
            <MenuItem
              key={"OpcionFila" + index}
              onClick={() => {
                accion.onClick(anchorEl.row);
                cerrarMenu();
              }}
            >
              {accion.label}
            </MenuItem>
          ))}
      </Menu> */}
      {ctl && ctl.length > 0
        ? ctl.map((vst) => (
            <React.Fragment>
              <br />
              <Card className={classes.card}>
                <CardHeader
                  avatar={
                    <React.Fragment>
                      {vst.idprioridad && vst.idprioridad == 1 ? (
                        <IconButton className={classes.redAvatar} size="small">
                          <Description fontSize="inherit" />
                        </IconButton>
                      ) : (
                        <IconButton className={classes.avatar1} size="small">
                          <Description fontSize="inherit" />
                        </IconButton>
                      )}
                    </React.Fragment>
                  }
                  action={
                    <React.Fragment>
                      <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={
                          vst.idestatus == 12
                            ? abrirMenuC(vst)
                            : vst.idestatus != 13
                            ? abrirMenu(vst)
                            : abrirMenuCe(vst)
                        }
                      >
                        <MoreVert />
                      </IconButton>
                    </React.Fragment>
                  }
                  titleTypographyProps={{ fontSize: 8, variant: "caption" }}
                  title={
                    vst.titulo.length > 12
                      ? vst.titulo.slice(0, -2) + "..."
                      : vst.titulo
                  }
                  // titleTypographyProps={{variant:'button' }}
                />
                {/* <CardHeader
                  // style={{ textAlign: "center" }}
                  titleTypographyProps={{ variant: "caption" }}
                  // className={classes.avatar}
                  title={vst.titulo}
                  
                /> */}
                {/* <Divider /> */}
                {/* <CardContent>
                  <Typography className={classes.avatar}>
                    {vst.idprioridad && vst.idprioridad == 1 ? (
                      <React.Fragment>
                        <WarningRounded
                          style={{ color: "red", width: 15, height: 20 }}
                        />
                      </React.Fragment>
                    ) : (
                      ""
                    )}{" "}
                  </Typography>
                </CardContent> */}
              </Card>
            </React.Fragment>
          ))
        : ""}
    </React.Fragment>

    // { ctl.tareas.length > 0
    //   ? ctl.tareas.map((vst) => (
    // <Card>
    //   <CardHeader
    //     style={{ textAlign: "center" }}
    //     title={vst.titulo}
    //     action={
    //       <React.Fragment>
    //         <MoreVert></MoreVert>
    //       </React.Fragment>
    //     }
    //   />
    //   <Divider />
    //   <CardContent>
    //     <Typography>
    //       {vst.prioridad && vst.prioridad == 1 ? (
    //         <React.Fragment>
    //           <WarningRounded style={{ color: "red", width: 20, height: 20 }} />
    //         </React.Fragment>
    //       )
    //       )) : ''}
    //       {vst.descripcion}
    //     </Typography>
    //   </CardContent>
    //   <Divider />
    // </Card>
  );
}
